import React from 'react';
import { CustomCheckedIcon, CustomIcon } from './styles';
import { Checkbox } from '@mui/material';

interface CustomCheckBoxProps {
  value: string;
  checked: boolean;
  setValue: (newValue: string) => void;
}

const CustomCheckBox: React.FC<CustomCheckBoxProps> = ({ value, checked, setValue }) => {
  const handleCheckboxChange = (value: string) => {
    setValue(value);
  };

  return <Checkbox icon={<CustomIcon />} checkedIcon={<CustomCheckedIcon />} value={value} checked={checked} onChange={() => handleCheckboxChange(value)} />;
};

export default CustomCheckBox;
